module.exports = {
    "id": "chichi",
    "title": "chichi",
    "image": "provision/parts/chichi/chichi.png",
    "info": [
      {
        "text": "Add chichi to your project",
        "image": "provision/parts/chichi/chichi.png"
      }
    ],
    "exposedVariables": []
  };